import React from "react";
import classes from './Symbol.module.css';

const TickSvg = () => {

    return (
        <>
            <svg className={classes["symbol"]} style={{ width: "100%", height: "100%", marginLeft: "0" }} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#008000" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="22 6 12 16.01 9 13.01"></polyline>
            </svg>

        </>
    )
};

export default TickSvg;
